import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';
import { isProductionEnvironment } from '../../utils/env';
import { useAccountSlug } from '../../hooks/useAccountSlug';

export const useCrossLinkToOfferingsInbox = inboxDictionary => {
  const slug = useAccountSlug();

  const isInboxMassOfferingsActive = useSelector(selectors.selectIsInboxMassOfferingsActive);

  if (!isInboxMassOfferingsActive) {
    return null;
  }

  if (isProductionEnvironment()) {
    const inboxMassOfferingsUrl = `https://moje.parafio.pl/${slug}/skrzynka-intencji`;

    const getInboxMassOfferingsUrl = type => {
      const typeParam = inboxDictionary.find(item => item.id === type)?.title;
      return `${inboxMassOfferingsUrl}${typeParam ? `?type=${typeParam}` : ''}`;
    };

    return getInboxMassOfferingsUrl;
  }

  const getInboxMassOfferingsUrl = type => {
    const typeParam = inboxDictionary.find(item => item.id === type)?.title;
    return `/inboxMassOfferings${typeParam ? `?type=${typeParam}` : ''}`;
  };

  return getInboxMassOfferingsUrl;
};
